'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeEmailIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeEmailIcon">
      <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1106_7)">
          <path
            d="M17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.3884 21.3795L18.585 18.1829C19.0731 17.6947 19.0731 16.9033 18.585 16.4151C18.0968 15.927 17.3054 15.927 16.8172 16.4151L13.6207 19.6117L8.71377 17.1582C7.72912 16.6659 7.81564 15.2333 8.85237 14.863L23.9211 9.48133C24.9144 9.12658 25.8735 10.0857 25.5188 11.0789L20.137 26.1478C19.7668 27.1845 18.3341 27.271 17.8418 26.2862L15.3884 21.3795Z"
            fill="#3D517B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1106_7">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeEmailIcon.propTypes = {
  sx: PropTypes.object
}
